/* eslint-disable */

import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import { withStyles } from 'material-ui/styles';
import green from 'material-ui/colors/green';
import { CircularProgress } from 'material-ui/Progress';
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import { FormControl } from 'material-ui/Form';
import Button from 'material-ui/Button';
import Visibility from 'material-ui-icons/Visibility';
import VisibilityOff from 'material-ui-icons/VisibilityOff';
import IconButton from 'material-ui/IconButton';
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';
import { translate } from 'react-i18next';

import worldIcon from '../assets/images/icons/world1.png';
import Menu from 'material-ui/Menu/Menu';
import MenuItem from 'material-ui/Menu/MenuItem';
import ReactCountryFlag from 'react-country-flag';

import headerBg from '../assets/images/landing/header-background.png';

import {
  usernameChanged,
  passwordChanged,
  loginStart,
  logoutStart,
  getCurrentUser,
  passwordVisibilityToggle,
  auth0Login,
  handleAuthenticationAuth0,
  setSessionAuth0,
  logoutAuth0,
  isAuthenticatedAuth0,
} from '../actions';

const drawerWidth = 240;

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'center',
  },
  appBarLanding: {
    backgroundColor: 'transparent',
    color: 'rgba(0, 0, 0, 0.54)',
    boxShadow: 'none',
    position: 'absolute',
    marginLeft: drawerWidth,
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
  },
  margin: {
    margin: theme.spacing.unit,
  },
  withoutLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  textField: {
    flexBasis: 200,
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

class Login extends React.Component {
  state = {};

  static contextTypes = {
    router: PropTypes.func.isRequired,
  };

  componentDidMount = () => {
    this.props.handleAuthenticationAuth0(this.props.history);
  };

  navigate() {
    const { router } = this.context;
    router.transitionTo('/test');
  }

  handleMenuClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  handleMenuContactClick = event => {
    this.setState({ anchorElContact: event.currentTarget });
  };

  handleMenuContactClose = () => {
    this.setState({ anchorElContact: null });
  };

  handleButtonCheckCertificate = () => {
    this.props.history.push('/certificates/check');
  };

  handleUsernameChange = () => event => {
    this.props.usernameChanged(event.target.value);
  };

  handlePasswordChange = () => event => {
    this.props.passwordChanged(event.target.value);
  };

  handleMouseDownPassword = event => {
    event.preventDefault();
  };

  handleClickShowPasssword = () => {
    this.props.passwordVisibilityToggle();
  };

  handleButtonLogin = () => {
    if (!this.props.loading) {
      this.props.loginStart(
        this.props.username,
        this.props.password,
        this.props.history
      );
    }
  };

  handleButtonLogout = () => {
    if (!this.props.loading) {
      this.props.logoutStart();
    }
  };

  handleButtonCheckCertificate = () => {
    if (!this.props.loading) {
      this.props.history.push('/certificates/check');
    }
  };

  handleButtonCheckFile = () => {
    if (!this.props.loading) {
      this.props.history.push('/reports/check');
    }
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  changeLanguage = lng => {
    this.props.i18n.changeLanguage(lng);
    this.handleMenuClose();
  };

  renderAuth0ButtonsOld() {
    const { classes, loading } = this.props;
    const buttonClassname = classNames({
      [classes.buttonSuccess]: loading,
    });

    return (
      <div>
        <div style={{ clear: 'both' }}>
          <div className={classes.wrapper} style={{ marginTop: 40 }}>
            <Button
              variant="flat"
              color="primary"
              className={buttonClassname}
              disabled={loading}
              onClick={() => this.props.auth0Login()}
            >
              Auth0 Login
            </Button>
            {loading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </div>
        <div style={{ clear: 'both' }}>
          <div className={classes.wrapper} style={{ marginTop: 40 }}>
            <Button
              variant="flat"
              color="primary"
              className={buttonClassname}
              disabled={loading}
              onClick={() => this.props.logoutAuth0()}
            >
              Auth0 Logout
            </Button>
            {loading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </div>
        <div style={{ clear: 'both' }}>
          <div className={classes.wrapper} style={{ marginTop: 40 }}>
            <Button
              variant="flat"
              color="primary"
              className={buttonClassname}
              disabled={loading}
              onClick={() => this.props.isAuthenticatedAuth0()}
            >
              Auth0 isAuthenticatedAuth0
            </Button>
            {loading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </div>
      </div>
    );
  }

  renderAuth0Buttons() {
    const { classes, loading, t } = this.props;
    const buttonClassname = classNames({
      [classes.buttonSuccess]: loading,
    });

    return (
      <div>
        <div style={{ clear: 'both' }}>
          <div className={classes.wrapper} style={{ marginTop: 100 }}>
            <Button
              variant="raised"
              color="primary"
              className={buttonClassname}
              disabled={loading}
              onClick={() => this.props.auth0Login()}
              type="submit"
            >
              {t('Sign In')}
            </Button>
            {loading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </div>
      </div>
    );
  }

  renderForm() {
    //Not used anymore, just keep it if we change the authentication method (currently using auth0)
    const {
      classes,
      t,
      username,
      password,
      passwordVisibility,
      loading,
    } = this.props;
    const buttonClassname = classNames({
      [classes.buttonSuccess]: loading,
    });

    return (
      <div style={{ clear: 'both' }}>
        <form onSubmit={() => this.handleButtonLogin()}>
          <FormControl
            className={classNames(classes.margin, classes.textField)}
          >
            <InputLabel htmlFor="adornment-username">
              {t('Username')}
            </InputLabel>
            <Input
              id="adornment-username"
              type="text"
              value={username}
              autoComplete="username"
              onChange={this.handleUsernameChange()}
            />
          </FormControl>
          <FormControl
            className={classNames(classes.margin, classes.textField)}
          >
            <InputLabel htmlFor="adornment-password">
              {t('Password')}
            </InputLabel>
            <Input
              id="adornment-password"
              type={passwordVisibility ? 'text' : 'password'}
              value={password}
              autoComplete="current-password"
              onChange={this.handlePasswordChange()}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Toggle password visibility"
                    onClick={this.handleClickShowPasssword}
                    onMouseDown={this.handleMouseDownPassword}
                  >
                    {passwordVisibility ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
          <div className={classes.wrapper}>
            <Button
              variant="raised"
              color="primary"
              className={buttonClassname}
              disabled={loading}
              onClick={() => this.handleButtonLogin()}
              type="submit"
            >
              {t('Sign In')}
            </Button>
            {loading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </form>
      </div>
    );
  }

  renderAppBar() {
    const { anchorEl, anchorElContact } = this.state;
    const { classes, t } = this.props;
    return (
      <AppBar className={classes.appBarLanding}>
        <Toolbar>
          <div style={{ position: 'absolute', right: 10, color: '#FFFFFF' }}>
            <Button
              color="inherit"
              onClick={() => this.handleButtonCheckCertificate()}
              style={{ fontFamily: 'Inter-Regular', textTransform: 'none' }}
            >
              {t('Check certificate')}
            </Button>
            <Button
              color="inherit"
              onClick={() => this.handleButtonCheckFile()}
              style={{ fontFamily: 'Inter-Regular', textTransform: 'none' }}
            >
              {t('Check report')}
            </Button>
            <Button
              aria-owns={anchorElContact ? 'contact-menu' : null}
              aria-haspopup="true"
              onClick={this.handleMenuContactClick}
              color="inherit"
              style={{ fontFamily: 'Inter-Regular', textTransform: 'none' }}
            >
              Contact
            </Button>
            <Menu
              id="contact-menu"
              anchorEl={anchorElContact}
              open={Boolean(anchorElContact)}
              onClose={this.handleMenuContactClose}
            >
              <MenuItem>contact@attributes.digital</MenuItem>
            </Menu>
            <IconButton
              aria-owns={anchorEl ? 'language-menu' : null}
              aria-haspopup="true"
              onClick={this.handleMenuClick}
              color="inherit"
            >
              <img src={worldIcon} style={{ maxHeight: 20 }} />
            </IconButton>
            <Menu
              id="language-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleMenuClose}
            >
              <MenuItem onClick={() => this.changeLanguage('fr')}>
                <ReactCountryFlag code="FR" />
              </MenuItem>
              <MenuItem onClick={() => this.changeLanguage('en')}>
                <ReactCountryFlag code="GB" />
              </MenuItem>
              <MenuItem onClick={() => this.changeLanguage('en_us')}>
                <ReactCountryFlag code="US" />
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
    );
  }

  render() {
    //const { classes, username, password, user, passwordVisibility, loading, error, isAuthenticated } = this.props;
    const { classes, t, i18n, user, loading, isAuthenticated } = this.props;
    const buttonClassname = classNames({
      [classes.buttonSuccess]: loading,
    });

    const headerBackgroundImageValue =
      'linear-gradient(to bottom, rgba(103,60,143,1), rgba(103,60,143,0.9), rgba(103,60,143,0.8), rgba(103,60,143,0.7), rgba(78,119,199,0.6), rgba(52,178,255,0.5), rgba(255,255,255,0))';

    if (isAuthenticated) {
      if (user.roles.includes('customerOfCustomer')) {
        return <Redirect to="/transport_certificates" />;
      }
      return <Redirect to="/assets/cons" />;
    }

    return (
      <div
        style={{
          backgroundImage: 'url(' + headerBg + ')',
          backgroundSize: 'contain',
          backgroundRepeat: 'repeat-y',
          backgroundPosition: 'center',
          height: '100vh',
        }}
      >
        <div
          className={classes.root}
          style={{
            justifyContent: 'center',
            flexWrap: 'nowrap',
            alignItems: 'center',
            alignContent: 'center',
            textAlign: 'center',
            display: 'inherit',
            backgroundImage: headerBackgroundImageValue,
            height: '100%',
          }}
        >
          {this.renderAppBar()}
          <div
            style={{
              marginLeft: 30,
              marginRight: 30,
              paddingTop: 160,
              paddingBottom: 0,
            }}
          >
            <div>
              <Typography
                variant="display1"
                gutterBottom
                style={{ color: '#FFFFFF', fontFamily: 'Inter-Regular' }}
              >
                {t('Welcome to Attributes')}
              </Typography>
              <Typography
                variant="body1"
                gutterBottom
                style={{ color: '#FFFFFF', fontFamily: 'Inter-Regular' }}
              >
                {t('We connect the green energy worlds through Blockchain.')}
              </Typography>
            </div>
            {this.renderAuth0Buttons()}
          </div>
        </div>
      </div>
    );
  }
}

Login.contextTypes = {
  router: PropTypes.object,
};
Login.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({ loginReducer, router }) => {
  const {
    username,
    password,
    loading,
    user,
    passwordVisibility,
    isAuthenticated,
  } = loginReducer;
  const { location } = router;
  return {
    username,
    password,
    loading,
    user,
    passwordVisibility,
    isAuthenticated,
    location,
  };
};

const mapDispatchToProps = {
  usernameChanged,
  passwordChanged,
  loginStart,
  logoutStart,
  getCurrentUser,
  passwordVisibilityToggle,
  auth0Login,
  handleAuthenticationAuth0,
  setSessionAuth0,
  logoutAuth0,
  isAuthenticatedAuth0,
};

//const MyConnectedComponent = withRouter(connect(mapStateToProps)(MyComponent))

Login = withStyles(styles, { name: 'Login' })(Login);
Login = translate('translations')(Login);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Login)
);



// WEBPACK FOOTER //
// ./src/components/Login.js